module.exports = __webpack_public_path__ + "components/country-flag/static/mv-c5f28e85fc6e07e20b0afbaef3e7f994.svg";